import React from 'react';
import VideoSelfieWithBiometricsLink from 'components/newIdentifyMethods/video/VideoSelfieBiometricsChoice/VideoSelfieWithBiometricsLink/VideoSelfieWithBiometricsLink';
import { useIdentityView } from 'routes/formsView/IdentityVerificationViews/IdentityView/contexts/IdentityViewContext/IdentityViewContext';
import VideoselfieWithoutBiometricsLink from 'components/newIdentifyMethods/video/VideoSelfieBiometricsChoice/VideoselfieWithoutBiometricsLink/VideoSelfieWithoutBiometricsLink';
import { IdentificationNotBiometricModal } from 'components/newAccountSteps/profileSteps/ProfileStep5/Modals/IdentificationNotBiometricModal/IdentificationNotBiometricModal';
import { useModal } from 'hooks/useModal';

const VideoSelfieBiometricsChoice = ({ isVideoSelfieSelected, isBiometricDecisionActive }) => {
    const { isSelectedVideoselfieWithBiometrics, setIsSelectedVideoselfieWithBiometrics } = useIdentityView();
    const { isOpen, toggleModal } = useModal();

    if (!isBiometricDecisionActive || !isVideoSelfieSelected) return null;

    if (isSelectedVideoselfieWithBiometrics) {
        const handleConfirm = () => {
            setIsSelectedVideoselfieWithBiometrics(false);
            toggleModal();
        };

        return (
            <>
                <VideoselfieWithoutBiometricsLink onClick={toggleModal} />
                <IdentificationNotBiometricModal showModal={isOpen} onConfirm={handleConfirm} onCancel={toggleModal} />
            </>
        );
    }

    return <VideoSelfieWithBiometricsLink onClick={() => setIsSelectedVideoselfieWithBiometrics(true)} />;
};

export default VideoSelfieBiometricsChoice;
